<template>

  <div class="py-4 container-fluid">
    <div class="row">

      <div class="col-md-8">
        <div class="card mb-2">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">Crear venta</p>
              <argon-button v-if="form.status != 1 && ((user.role !== '1' && form.status == 0) || user.role === '1')" color="success"
                size="sm" class="ms-auto" @click="save">Guardar</argon-button>
              <argon-button v-if="(user.role !== '1' && form.status == 0) || (user.role === '1' && form.status == 0)" color="success"
                size="sm" class="" style="margin-left: 5px;" @click="confirm">Formalizar</argon-button>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <label for="example-text-input" class="form-control-label">Cliente</label>
                <div class="d-flex gap-2">
                  <select class="form-select flex-grow-1" v-model="form.cliente_id" @change="selectClient" :disabled="form.status == 1">
                    <option value="">Seleccione un cliente</option>
                    <option v-for="client in clients" :key="client.id" :value="client.id">
                      {{ client.name }} - {{ client.document }}
                    </option>
                  </select>
                  <argon-button v-if="form.status != 1" color="success" size="sm" @click="openAddClientModal">Agregar</argon-button>
                </div>
              </div>
              <div class="col-md-12">
                <label for="example-text-input" class="form-control-label">Observación</label>
                <ArgonTextarea type="text" v-model="form.observation" :disabled="form.status == 1" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-10">
        <div class="card" v-if="form.id != 0">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="text-uppercase mb-0">Lista de detalles</p>
              <argon-button v-if="user.role === '1'" color="success" size="sm" class="ms-auto"
                @click="addDetail">Agregar producto</argon-button>
            </div>
          </div>

          <div class="card-body">
            <div class="row">
              <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Producto</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Referencia</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cantidad</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Precio</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total</th>
                      <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center"
                        v-if="(user.role !== '1' && form.status === 0) || user.role === '1'">
                        Opciones
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="value in data.data" :key="value.id">
                      <td>
                        <div class="d-flex px-2 py-1">
                          <div class="d-flex flex-column justify-content-center">
                            <h6 class="mb-0 text-sm">{{ value.produccion?.name ?? 'No encontrado' }}</h6>
                          </div>
                        </div>
                      </td>
                      <td class="align-middle text-center text-sm">
                        {{ value.produccion?.ref ?? "No encontrado" }}
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          {{ value.quantity }}
                        </span>
                      </td>

                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          {{ parseFloat(value.price ?? 0).toLocaleString('es-ES', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          }) }}
                        </span>
                      </td>

                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          {{ parseFloat(value.total ?? 0).toLocaleString('es-ES', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          }) }}
                        </span>
                      </td>

                      <td class="align-middle text-center">

                        <a @click="editRegister(value)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                          data-toggle="tooltip" data-original-title="Eliminar registro">
                          <i class="fa fa-pencil-alt"></i>
                        </a>

                        <a @click="deleteRegister(value.id)"
                          class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 15px;"
                          data-toggle="tooltip" data-original-title="Eliminar registro">
                          <i class="fa fa-trash"></i>
                        </a>
                      </td>
                    </tr>

                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal agregar detalles de Pedido -->
    <div class="modal fade" id="ModalBudget" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Agregar producto</h5>
            <button type="button" class="btn-close" @click="submitForm"></button>
          </div>
          <div class="modal-body">
            <form>

              <div class="mb-3">
                <label for="amount" class="form-label">Producto</label>
                <select ref="ProductionSelect" class="form-select select2" style="width:100%;">
                </select>
              </div>

              <!--  <div class="mb-3">
                <label for="amount" class="form-label">Referencia</label>
                <select ref="ModelSelect" class="form-select select2" style="width:100%;">
                </select>
              </div> -->

              <div class="mb-3">
                <label for="amount" class="form-label">Cantidad</label>
                <input type="text" v-model="modal.quantity" id="total_price" class="form-control"
                  placeholder="Ingrese el valor total">
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Precio Unidad</label>
                <input type="text" v-model="formattedPrice" id="amount" class="form-control"
                  placeholder="Ingrese el valor">
              </div>
              <div class="mb-3">
                <label for="amount" class="form-label">Total</label>
                <input type="text" v-model="totalPrice" id="total_price" class="form-control"
                  placeholder="Ingrese el valor total">
              </div>

            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="submitForm">Guardar</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Agregar Cliente -->
  <div class="modal fade" id="ModalAddClient" tabindex="-1" aria-labelledby="addClientModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content card">
        <div class="modal-header">
          <h5 class="modal-title" id="addClientModalLabel">Agregar Cliente</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form>
            <div class="mb-3">
              <label for="client-name" class="form-label">Nombre *</label>
              <input type="text" v-model="newClient.name" id="client-name" class="form-control" placeholder="Ingrese el nombre" required>
            </div>
            <div class="mb-3">
              <label for="client-document-type" class="form-label">Tipo de Documento *</label>
              <select id="client-document-type" class="form-control" v-model="newClient.document_type" required>
                <option value="" disabled>Seleccione un tipo de documento</option>
                <option value="CC">Cédula de Ciudadanía (CC)</option>
                <option value="CE">Cédula de Extranjería (CE)</option>
                <option value="TI">Tarjeta de Identidad (TI)</option>
                <option value="RC">Registro Civil (RC)</option>
                <option value="PA">Pasaporte (PA)</option>
                <option value="PEP">Permiso Especial de Permanencia (PEP)</option>
                <option value="NIT">Número de Identificación Tributaria (NIT)</option>
              </select>
            </div>
            <div class="mb-3">
              <label for="client-document" class="form-label">Número de Documento *</label>
              <input type="text" v-model="newClient.document" id="client-document" class="form-control" placeholder="Ingrese el número de documento" required>
            </div>
            <div class="mb-3">
              <label for="client-email" class="form-label">Email</label>
              <input type="email" v-model="newClient.email" id="client-email" class="form-control" placeholder="Ingrese el email">
            </div>
            <div class="mb-3">
              <label for="client-phone" class="form-label">Teléfono</label>
              <input type="text" v-model="newClient.phone" id="client-phone" class="form-control" placeholder="Ingrese el teléfono">
            </div>
            <div class="mb-3">
              <label for="client-address" class="form-label">Dirección</label>
              <input type="text" v-model="newClient.address" id="client-address" class="form-control" placeholder="Ingrese la dirección">
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeAddClientModal">Cerrar</button>
          <button type="button" class="btn btn-primary" @click="saveClient">Guardar</button>
        </div>
      </div>
    </div>
  </div>



</template>

<script>
import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonTextarea from "../../../components/ArgonTextarea.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import { useRoute } from "vue-router";
import Swal from 'sweetalert2';
import $ from 'jquery';
import 'select2/dist/css/select2.css';
import 'select2';
import { Modal } from 'bootstrap';
import userService from '../../../services/user.service';


const body = document.getElementsByTagName("body")[0];

export default {
  name: "Remissions Create",
  data() {
    return {
      showMenu: false,
      modalBudget: null,
      isFinish: false,
      filter: {
        production_id: [],
        model_id: [],
        oficio_id: [],
        user_id: [],
      },
      models: [],
      user: {},
      form: {
        id: 0,
        cliente_id: '',
        name: '',
        document_type: '',
        document: '',
        address: '',
        phone: '',
        email: '',
        observation: '',
        status: 0,
        type: 'sale',
      },
      data: {},
      modal: {
        id: 0,
        remission_id: 0,
        production_id: 0,
        model_id: 0,
        quantity: 1,
        price: 0,
        total: 0
      },
      modalEvidencia: [],
      suppliers: [],
      filteredSuppliers: [],
      clients: [],
      modalAddClient: null,
      newClient: {
        name: '',
        email: '',
        phone: '',
        document: '',
        document_type: '',
        address: '',
        role: '4', // Cliente
        status: 1,
        payment: '0',
      },
    };
  },
  components: { ArgonButton, ArgonTextarea },
  computed: {
    formattedPrice: {
      get() {
        return this.modal.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        this.modal.price = Math.floor(value.replace(/\./g, "") || 0);
        this.modal.total = Math.floor(this.modal.price * this.modal.quantity);
      },
    },
    totalPrice: {
      get() {
        return this.modal.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        this.modal.total = Math.floor(value.replace(/\./g, "") || 0);
        this.modal.price = this.modal.quantity > 0 ? Math.floor((this.modal.total / this.modal.quantity)) : 0;
      },
    },
  },
  watch: {
    "modal.quantity"(newQuantity) {
      this.modal.total = Math.floor(this.modal.price * newQuantity);
    },
  },
  methods: {
    async getClients(){
      try {
        const response = await userService.getAll('all');
        const allUsers = response.data.data || response.data || [];
        // Filtrar solo clientes (role === '4')
        this.clients = allUsers.filter(user => user.role === '4');
      } catch (error) {
        console.error('Error fetching clients:', error);
      }
    },
    selectClient() {
      const selectedClient = this.clients.find(c => c.id == this.form.cliente_id);
      if (selectedClient) {
        this.form.name = selectedClient.name;
        this.form.email = selectedClient.email || '';
        this.form.phone = selectedClient.phone || '';
        this.form.document = selectedClient.document || '';
        this.form.document_type = selectedClient.document_type || '';
        this.form.address = selectedClient.address || '';
      }
    },
    openAddClientModal() {
      const modalElement = document.getElementById('ModalAddClient');
      this.modalAddClient = new Modal(modalElement);
      this.modalAddClient.show();
    },
    closeAddClientModal() {
      if (this.modalAddClient) {
        this.modalAddClient.hide();
      }
      // Resetear formulario
      this.newClient = {
        name: '',
        email: '',
        phone: '',
        document: '',
        document_type: '',
        address: '',
        role: '4',
        status: 1,
        payment: '0',
      };
    },
    async saveClient() {
      try {
        // Validar campos requeridos
        if (!this.newClient.name || !this.newClient.document || !this.newClient.document_type) {
          Swal.fire('Error', 'Por favor complete todos los campos requeridos', 'error');
          return;
        }

        // Crear el cliente (sin contraseña, se generará en el backend)
        const clientData = {
          ...this.newClient,
          password: this.newClient.document + '-Alavision',
          password_confirmation: this.newClient.document + '-Alavision',
        };

        const response = await userService.createUser(clientData);
        
        if (response && response.status >= 200 && response.status < 300) {
          Swal.fire('Éxito', 'Cliente creado correctamente', 'success');
          this.closeAddClientModal();
          // Recargar lista de clientes
          await this.getClients();
          // Seleccionar el cliente recién creado
          this.form.cliente_id = response.data.id;
          this.selectClient();
        } else {
          throw new Error(response?.data?.message || 'Error al crear el cliente');
        }
      } catch (error) {
        console.error('Error creating client:', error);
        const errorMsg = error.response?.data?.message || error.message || 'Error al crear el cliente';
        Swal.fire('Error', errorMsg, 'error');
      }
    },
    async getProductions() {
      this.productions = await this.$store.dispatch('inventory/getAll');

      this.$nextTick(async () => {

        const select = $(this.$refs.ProductionSelect);

        // Destruir select2 si ya está inicializado
        if (select.hasClass("select2-hidden-accessible")) {
          select.select2('destroy');
        }

        select.empty();

        select.append('<option value="" disabled selected>Seleccionar Producción</option>');
        this.productions.forEach(prod => {
          select.append(new Option(`#${prod.id} - ${prod.name}`, prod.id, false, false));
        });

        $(this.$refs.ProductionSelect).select2({
          placeholder: 'Seleccionar Producción',
          allowClear: false,
          dropdownParent: $('#ModalBudget .modal-body')
        });

        $(this.$refs.ProductionSelect).on('change', async () => {
          this.modal.production_id = $(this.$refs.ProductionSelect).val();

          const selectedModel = this.productions.find(prod => prod.id == this.modal.production_id);
          if (selectedModel) {

            this.modal.price = parseFloat(selectedModel.sale_price);

            this.modal.total = Math.floor(this.modal.price * this.modal.quantity);
          }

          //await this.getModels();
        })
      });
    },
    async getModels() {
      this.models = await this.$store.dispatch('productionModels/getData', this.modal.production_id);

      this.$nextTick(() => {
        const select = $(this.$refs.ModelSelect);

        if (select.hasClass("select2-hidden-accessible")) {
          select.select2('destroy');
        }
        select.empty();
        select.append('<option value="" disabled selected>Seleccionar referencia</option>');
        this.models.data.forEach(prod => {
          select.append(new Option(`#${prod.model.id} - ${prod.model.name} (${prod.model.ref}) - TALLA: ${prod.size.size} - COLOR: ${prod.size.color.name} `, prod.model.id, false, false));
        });

        $(this.$refs.ModelSelect).select2({
          placeholder: 'Seleccione una referencia',
          allowClear: false,
          dropdownParent: $('#ModalBudget .modal-body')
        });

        $(this.$refs.ModelSelect).on('change', () => {
          this.modal.model_id = $(this.$refs.ModelSelect).val();

          const selectedModel = this.models.data.find(prod => prod.model.id == this.modal.model_id);
          if (selectedModel) {

            this.modal.price = parseFloat(selectedModel.model.price);

            if (this.modal.id == 0) {
              this.modal.quantity = selectedModel.quantity_to_produce;
            }

            this.modal.total = Math.floor(this.modal.price * this.modal.quantity);
          }
        });
      });
    },
    addDetail() {
      this.modal.id = 0;
      this.modal.production_id = 0;
      this.modal.model_id = 0;
      this.modal.quantity = 1;
      this.modal.price = 0;
      this.modal.total = 0;

      this.getProductions();
      //this.getModels();
      $(this.$refs.ModelSelect).val("").trigger('change');

      this.openModal();
    },
    openModal() {
      const modalElement = document.getElementById('ModalBudget');
      this.modalBudget = new Modal(modalElement); // Guarda la instancia del modal
      this.modalBudget.show(); // Muestra el modal
    },
    closeModal() {
      if (this.modalBudget) {
        this.modalBudget.hide(); // Cierra el modal
      }
    },
    async getData() {
      this.data = await this.$store.dispatch('remissionsDetails/getData', this.form.id);
    },
    async confirm() {
      await Swal.fire({
        icon: 'info',
        title: 'Formalizar venta',
        text: 'Al formalizar la venta ya no se podrá editar los registros ni los detalles de la venta, y se restarán las cantidades del inventario',
        confirmButtonText: 'Aceptar',
        backdrop: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.form.status = 1;
          this.save();
        }
      });
    },
    async save() {
      try {
        // Validar que se haya seleccionado un cliente
        if (!this.form.cliente_id) {
          Swal.fire('Error', 'Por favor seleccione un cliente', 'error');
          return;
        }

        // Obtener el usuario actual para user_id
        const currentUser = JSON.parse(localStorage.getItem('user'));
        if (!currentUser || !currentUser.id) {
          Swal.fire('Error', 'No se pudo obtener la información del usuario', 'error');
          return;
        }

        // Preparar datos para guardar
        const remissionData = {
          id: this.form.id || 0,
          user_id: currentUser.id,
          cliente_id: this.form.cliente_id,
          observation: this.form.observation || '',
          type: this.form.type || 'sale',
          status: this.form.status || 0,
        };

        // Dispara la acción de Vuex para guardar
        const response = await this.$store.dispatch("remissions/save", remissionData);
        if (response && response.status >= 200 && response.status < 300) {
          const message = this.form.status == 1 
            ? 'La venta ha sido formalizada correctamente. Las cantidades se han restado del inventario.'
            : 'El registro ha sido guardado correctamente. Ahora puede agregar los productos.';
          
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: message,
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.form.id = response.data.id;
              this.getProductions();
            }
          });

        } else {
          throw new Error(response.data.message || 'Error al guardar la venta');
        }

      } catch (error) {
        console.error("Error al crear la venta:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar la venta',
        });
      }
    },
    async submitForm() {
      try {
        // Dispara la acción de Vuex para guardar el modal
        this.modal.remission_id =   this.form.id;
        const response = await this.$store.dispatch("remissionsDetails/save", this.modal);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {

              this.modal.id = 0;
              this.modal.production_id = 0;
              this.modal.model_id = 0;
              this.modal.quantity = 1;
              this.modal.price = 0;
              this.modal.total = 0;

              $(this.$refs.processesSelect).val('').trigger('change');

              this.getData();
              this.closeModal();
            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }

    },
    async editRegister(params) {
      this.modal = params;

      this.modal.id = params.id;
      this.modal.produccion = params.production_id;
      this.modal.model = params.model_id;

      $(this.$refs.ProductionSelect).val(params.production_id).trigger('change');

      this.openModal();

      await new Promise(resolve => setTimeout(resolve, 1000));

      $(this.$refs.ModelSelect).val(params.model_id).trigger('change');
      this.modal.quantity = params.quantity;
      this.modal.price = params.price;
      this.modal.total = params.total;

    },
    async deleteRegister(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("remissionsDetails/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );

            this.getData();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
  },
  async mounted() {

    this.user = JSON.parse(localStorage.getItem('user'));
    const route = useRoute();
    const dataEdit = route.params.data;

    // Cargar clientes primero para que estén disponibles al cargar la venta
    await this.getClients();

    if (dataEdit) {

      this.getProductions();

      try {
        const params = JSON.parse(dataEdit); // Asegúrate de que este JSON se pueda parsear
        this.data = params;
        if (params && params.id) {

          this.form.id = params.id || 0;
          // Convertir cliente_id a número si existe
          this.form.cliente_id = params.cliente_id ? parseInt(params.cliente_id) : '';
          this.form.name = params.name || '';
          this.form.document_type = params.document_type || '';
          this.form.document = params.document || '';
          this.form.address = params.address || '';
          this.form.phone = params.phone || '';
          this.form.email = params.email || '';
          this.form.type = params.type || 'sale';
          this.form.observation = params.observation || '';
          this.form.status = params.status || 0;

          this.modal.remission_id = params.id || 0;

          // Si hay cliente_id, seleccionar el cliente después de que se carguen los clientes
          this.$nextTick(() => {
            if (this.form.cliente_id) {
              this.selectClient();
            }
          });

          this.getData();
        }
      } catch (error) {
        console.error("Error al parsear los datos del registro:", error);
      }
    }
    this.$store.state.isAbsolute = false;
    setNavPills();
    setTooltip();
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>

<style>
.disabled-link {
  color: gray;
  pointer-events: none;
  /* Impide la interacción */
  cursor: not-allowed;
  /* Cambia el cursor para indicar que está deshabilitado */
}
</style>
